import { Chip } from "@mui/material";
import { formatLabel } from "helpers/functions/formatLabel";
import { useHandleBack } from "helpers/functions/useHandleBack";
import React, { useEffect } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Row,
  Spinner,
  Table,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { fetchItemById } from "slices/item/thunk";
import PriceStatusChip from "./PriceStatusChip";

const ViewItemDetails: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();

  const handleBack = useHandleBack("/item");

  const { selectedItem, loading } = useSelector(
    (state: any) => state.ItemReducer
  );

  useEffect(() => {
    if (id) {
      dispatch(fetchItemById(id));
    }
  }, [id, dispatch]);

  console.log(selectedItem);

  return (
    <div className="page-content px-4">
      <Card className="mb-4 p-3">
        {/* Breadcrumb / Header */}
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2 mb-3">
          {/* Left: Back icon and heading */}
          <div className="d-flex align-items-center gap-2">
            <span
              style={{ fontSize: "24px", cursor: "pointer" }}
              onClick={handleBack}
            >
              ←
            </span>
            <h5 className="mb-0 fw-bold">View Item Details</h5>
          </div>

          {/* Right: Breadcrumb */}
          <div className="text-muted">
            <Link
              to="/item"
              className="text-muted"
              style={{ fontSize: "0.9rem", cursor: "pointer" }}
            >
              Item
            </Link>{" "}
            &gt;{" "}
            <span
              className="text-muted"
              style={{ fontSize: "0.9rem", cursor: "pointer" }}
            >
              Item Details
            </span>
          </div>
        </div>

        {loading ? (
          <Container className="py-4 flex text-center ">
            <Spinner animation="border" role="status" variant="primary">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </Container>
        ) : !selectedItem && !loading ? (
          <Container className="py-4 flex text-center ">
            <h4>No item found</h4>
          </Container>
        ) : (
          <Card.Body>
            <h5 className="mb-0 fw-bold">Item Details</h5>
            <hr />
            <Row>
              <Col xl={4} md={6} xs={12} className="mb-3">
                <strong>Item Name :</strong> {selectedItem?.item_name || "-"}
              </Col>
              <Col xl={4} md={6} xs={12} className="mb-3">
                <strong>Category Name :</strong>{" "}
                {selectedItem?.category_name || "-"}
              </Col>
              <Col xl={4} md={6} xs={12} className="mb-3">
                <strong>Item SKU :</strong> {selectedItem?.item_sku || "-"}
              </Col>
              {/* <Col xl={4} md={6} xs={12} className="mb-3">
                <strong>New Item :</strong>{" "}
                {selectedItem?.item_is_new ? "Yes" : "No"}
              </Col> */}
              <Col xl={4} md={6} xs={12} className="mb-3">
                <strong>Price Status :</strong>{" "}
                <PriceStatusChip status={selectedItem?.price_status} />
                {!selectedItem?.price_status && "-"}
                </Col>
              <Col xl={4} md={6} xs={12} className="mb-3">
                <strong>Brand :</strong> {selectedItem?.brand_name || "-"}
              </Col>
              <Col xl={4} md={6} xs={12} className="mb-3">
                <strong>HSN Code :</strong> {selectedItem?.hsn_name || "-"}
              </Col>
              <Col xl={4} md={6} xs={12} className="mb-3">
                <strong>Purchase Price :</strong> ₹{" "}
                {Number(selectedItem?.purchase_price || 0).toLocaleString(
                  "en-IN",
                  { maximumFractionDigits: 2 }
                )}
              </Col>
              <Col xl={4} md={6} xs={12} className="mb-3">
                <strong>Regular Price :</strong> ₹{" "}
                {Number(selectedItem?.regular_price || 0).toLocaleString(
                  "en-IN",
                  { maximumFractionDigits: 2 }
                )}
              </Col>
              <Col xl={4} md={6} xs={12} className="mb-3">
                <strong>%WEB :</strong>{" "}
                {selectedItem?.web_per ? `${selectedItem.web_per}` : "-"}
              </Col>
              <Col xl={4} md={6} xs={12} className="mb-3">
                <strong>%System :</strong>{" "}
                {selectedItem?.system_per ? `${selectedItem.system_per}` : "-"}
              </Col>
              <Col xl={4} md={6} xs={12} className="mb-3">
                <strong>Sale Price (Web) :</strong> ₹{" "}
                {Number(selectedItem?.sale_price || 0).toLocaleString("en-IN", {
                  maximumFractionDigits: 2,
                })}
              </Col>
              <Col xl={4} md={6} xs={12} className="mb-3">
                <strong>Selling Price (System) :</strong> ₹{" "}
                {Number(selectedItem?.selling_price || 0).toLocaleString(
                  "en-IN",
                  { maximumFractionDigits: 2 }
                )}
              </Col>
              <Col xl={4} md={6} xs={12} className="mb-3">
                <strong>GST :</strong> {selectedItem?.gst || "-"}
              </Col>
              <Col xl={4} md={6} xs={12} className="mb-3">
                <strong>Quantity :</strong> {selectedItem?.quantity || "-"}
              </Col>
              <Col xl={4} md={6} xs={12} className="mb-3">
                <strong>Tags :</strong>{" "}
                {selectedItem?.tags && selectedItem.tag_names.length > 0
                  ? selectedItem.tag_names.map((tag: any, idx: number) => (
                      <Chip
                        key={idx}
                        label={tag}
                        size="small"
                        className="me-1"
                      />
                    ))
                  : "-"}
              </Col>
              <Col xl={8} md={12} xs={12} className="mb-3">
                <strong>Remarks :</strong>{" "}
                {selectedItem?.remarks ? selectedItem.remarks : "-"}
              </Col>
            </Row>
          </Card.Body>
        )}
      </Card>

      {/* Product Image */}
      {selectedItem && !loading && selectedItem?.image && (
        <Card className="mb-4">
          <Card.Header>
            <h5 className="mb-0 fw-bold">Product Image</h5>
          </Card.Header>
          <Card.Body className="p-3">
            <div className="d-flex justify-content-center">
              <img
                src={selectedItem.image}
                alt="Product"
                style={{
                  maxWidth: "300px",
                  maxHeight: "300px",
                  objectFit: "contain",
                  borderRadius: "8px",
                  border: "1px solid #ddd",
                }}
              />
            </div>
          </Card.Body>
        </Card>
      )}

      {/* Attributes Table */}
      {selectedItem && !loading && selectedItem?.attributes.length > 0 && (
        <Card>
          <Card.Header>
            <h5 className="mb-0 fw-bold">Attributes</h5>
          </Card.Header>
          <Card.Body className="p-3">
            <Table
              bordered
              hover
              responsive
              className="mb-0 text-center align-middle"
            >
              <thead className="table-light">
                <tr>
                  <th>Attributes</th>
                  <th>Value</th>
                </tr>
              </thead>
              <tbody>
                {selectedItem?.attributes &&
                  selectedItem.attributes.map((attr: any) => (
                    <tr key={attr.item_attribute_id}>
                      <td>{formatLabel(attr.attribute_name)}</td>
                      <td>{attr.manage_value_name}</td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      )}

      {!loading && (
        <Card>
          <div className="my-4 text-center">
            <Button
              // variant="outline-secondary"
              // style={{
              //   color: "#878899",
              //   borderColor: "#B0BAC9",
              //   backgroundColor: "transparent",
              // }}
              onClick={handleBack}
              className="btn btn-secondary"
            >
              Back
            </Button>
          </div>
        </Card>
      )}
    </div>
  );
};

export default ViewItemDetails;
